import createReactComponent from '../createReactComponent';
export default createReactComponent('line-dotted', 'IconLineDotted', [
  ['path', { d: 'M4 12v.01', key: 'svg-0' }],
  ['path', { d: 'M8 12v.01', key: 'svg-1' }],
  ['path', { d: 'M12 12v.01', key: 'svg-2' }],
  ['path', { d: 'M16 12v.01', key: 'svg-3' }],
  ['path', { d: 'M20 12v.01', key: 'svg-4' }],
]);
